import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import RealTimeClient from '../Services/RealTimeClient';

const initialState: any = { data: {} };

/**
 * Arms the shared Beacon WebSocket. The phone-line tab is the only one that
 * calls /api/v1/beacon/connect. A dispatch from a follower does not open a socket.
 */
export const getBeacon: any = createAsyncThunk(
  "getBeacon/post",
  async () => {
    RealTimeClient.armBeacon();
    return { data: null };
  }
);

const beaconSlice = createSlice({
  name: 'beacon',
  initialState,
  reducers: {},
  extraReducers: {
    [getBeacon.fulfilled]: (state, action) => {
      const data = action.payload?.data;
      if (!data?.connectionUrl || !data?.accessToken) {
        return;
      }
      state.data = data;
      void RealTimeClient.connect(data.connectionUrl, data.accessToken);
    },
  }
});

const { reducer } = beaconSlice;
export default reducer;
